import TwoColumnImagePanel from "@/components/TwoColumnImagePanel.vue";
import { useBuilderShowIf } from "../composables/builderFieldUtility";
import { builderCta } from "@/helpers/builder-init/index";
import { useColors } from "@/helpers/composables/useColors";

const { hasValue, hasValueEqualTo, hasRichText } = useBuilderShowIf();
const { colors } = useColors();

export const twoColumnImagePanelInit = {
    component: TwoColumnImagePanel,
    name: "50 50 Inset Quote",
    inputs: [
        {
            name: "textContent",
            type: "object",
            default: {},
            subFields: [
                {
                    name: "eyebrow",
                    friendlyName: "Eyebrow Text",
                    type: "string",
                    defaultValue: "Eyebrow"
                },
                {
                    name: "eyebrowColor",
                    friendlyName: "Eyebrow Color",
                    type: "string",
                    enum: Object.keys(colors),
                    showif: hasValue('eyebrow')
                },
                {
                    name: "eyebrowImage",
                    friendlyName: "Eyebrow Image",
                    type: "file",
                    allowedFileTypes: ["jpeg", "png", "svg"]
                },
                {
                    name: "header",
                    friendlyName: "Header Text",
                    type: "string",
                    defaultValue: "Header"
                },
                {
                    name: "headerColor",
                    friendlyName: "Header Color",
                    type: "string",
                    enum: Object.keys(colors),
                    showif: hasValue('header')
                },
                {
                    name: "body",
                    friendlyName: "Body Text",
                    type: "string",
                    defaultValue: "Body"
                },
                {
                    name: "bodyColor",
                    friendlyName: "Body Color",
                    type: "string",
                    enum: Object.keys(colors),
                    showif: hasValue('body')
                },
                {
                    name: "cta",
                    friendlyName: "CTA",
                    type: "object",
                    defaultValue: builderCta.defaultValue,
                    subFields: [...builderCta.subFields]
                },
                {
                    name: "textAlignment",
                    friendlyName: "Text Alignment",
                    type: "string",
                    defaultValue: "left",
                    enum: ["left", "center", "right"]
                }
            ]
        },
        {
            name: "media",
            type: "object",
            default: {},
            subFields: [
                {
                    name: "type",
                    type: "string",
                    enum: ["image", "video"]
                },
                {
                    name: "file",
                    helperText:
                        "Allowed file types - .jpeg, .png, .mp4, .gif, .svg",
                    allowedFileTypes: ["jpeg", "png", "mp4", "gif", "svg"],
                    type: "file"
                },
                {
                    name: "altText",
                    type: "string",
                    helperText: "Image Alt",
                }
            ]
        },
        {
            name: "backgroundImage",
            type: "object",
            default: {},
            subFields: [
                {
                    name: "type",
                    type: "string",
                    enum: ["image", "video"]
                },
                {
                    name: "file",
                    helperText:
                        "Allowed file types - .jpeg, .png, .mp4, .gif, .svg",
                    allowedFileTypes: ["jpeg", "png", "mp4", "gif", "svg"],
                    type: "file"
                },
                {
                    name: "alt",
                    type: "string",
                    helperText: "Image Alt",
                }
            ]
        },
        {
            name: "quoteContent",
            type: "object",
            default: {},
            subFields: [
                {
                    name: "eyebrow",
                    friendlyName: "Eyebrow Text",
                    type: "string"
                },
                {
                    name: "eyebrowColor",
                    friendlyName: "Eyebrow Color",
                    type: "string",
                    enum: Object.keys(colors),
                    showif: hasValue('eyebrow')
                },
                {
                    name: "headline",
                    friendlyName: "Headline Text",
                    type: "string"
                },
                {
                    name: "headlineColor",
                    friendlyName: "Headline Color",
                    type: "string",
                    enum: Object.keys(colors),
                    showif: hasValue('headline')
                },
                {
                    name: "cta",
                    friendlyName: "CTA",
                    type: "object",
                    defaultValue: builderCta.defaultValue,
                    subFields: [...builderCta.subFields]
                }
            ]
        },
        {
            name: "reversePositioning",
            type: "boolean",
            defaultValue: false
        },
        // {
        //     name: "roundedCorners",
        //     type: "boolean",
        //     defaultValue: false
        // },
        // {
        //     name: "margin",
        //     friendlyName: "Margin (px)",
        //     type: "number",
        //     defaultValue: 0
        // },
        // {
        //     name: "foregroundColor",
        //     type: "color",
        //     defaultValue: null
        // },
        {
            name: "backgroundColor",
            type: "color",
            defaultValue: null
        }
    ]
};
